module.exports = __webpack_public_path__ + "img/semaforo.9d267c4e.jpeg";